module.exports = __webpack_public_path__ + "img/header-diamondJewelryRedgold.b25a305.webp";